import { render, staticRenderFns } from "./cursos.vue?vue&type=template&id=796bcf85"
import script from "./cursos.vue?vue&type=script&lang=js"
export * from "./cursos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports